import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private instance: Storage = null;

  constructor(private storage: Storage) {}

  async initStorage() {
    this.instance = await this.storage.create();
  }

  set(key: string, value: any) {
    return this.instance.set(key, value);
  }

  get(key: string) {
    return this.instance.get(key);
  }

  clear() {
    return this.instance.clear();
  }
}
